import { Getters } from "vuex-smart-module";
import UserState from "./state";

export default class UserGetters extends Getters<UserState> {
  get profile() {
    return this.state.profile;
  }
  get userId() {
    return this.state.profile.id;
  }
  get userName() {
    return this.state.profile.username;
  }
  get fullName() {
    return this.state.profile.full_name;
  }
  get isProfileLoaded() {
    return this.state.loaded;
  }
  get isAdmin() {
    return this.state.profile.is_admin;
  }
}
